import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import BodyWrap from "../../utils/BodyWrap";
import GeneralLoader from "../../GeneralLoader";
import ContentDiv from "../../utils/ContentDiv";
import ErrorWrap from "../../utils/error-success/ErrorWrap";
import SuccessWrap from "../../utils/error-success/SuccessWrap";
import Button from "../../utils/Button";
import PasswordRequestLinks from "./PasswordRequestLinks";

// State
import { passwordRequest } from "../../../store/actions/user";
import { getTranslations } from "../../../store/actions/translations";

class PasswordRequest extends Component {
	constructor(props) {
		super(props);

		this.state = {
			email: ""
		};
	}

	static initialAction(store, props, translationKey = null) {
		const promises = [];
		const translationSections = ["reviewer_password_request"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		const resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		return promises;
	}

	// ===================================================================================
	//  LIFE CYCLE
	// ===================================================================================
	componentWillMount() {
		// Grab translations if not already in store
		if (!this.props.translations.pages[this.props.translationKey]) {
			PasswordRequest.initialAction(null, this.props);
		}
	}

	// ===================================================================================
	//  INPUT HANDLING
	// ===================================================================================
	handleInputChange(event) {
		event.preventDefault();
		this.setState({
			[event.target.id]: event.target.value
		});
	}

	handleKeyPress(event) {
		if (event.key === "Enter") {
			this.handleSubmit(event);
		}
	}

	handleSubmit = () => {
		this.props.passwordRequest(this.state.email);
	};

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		const { isLoading, success, errors, translationsLoading, translations } = this.props;

		return (
			<BodyWrap>
				<main className="content-bottom-margin">
					<div className="content-header centered">
						{translationsLoading ? (
							<GeneralLoader />
						) : !!translations.pages[this.props.translationKey] ? (
							<ContentDiv className="page-text">
								{translations.pages[this.props.translationKey].content}
							</ContentDiv>
						) : null}
					</div>

					{!translationsLoading && (
						<React.Fragment>
							<div className="centered-form">
								<div className="form-title">
									{
										translations.sections.reviewer_password_request
											.enter_email_label
									}
								</div>
								<div className="form-content">
									{success ? (
										<SuccessWrap>
											<ContentDiv>
												{
													translations.sections.reviewer_password_request
														.success_message
												}
											</ContentDiv>
										</SuccessWrap>
									) : (
											<React.Fragment>
												<div className="centered-form-field">
													{errors.email && (
														<ErrorWrap animate={1}>
															{errors.email}
														</ErrorWrap>
													)}
													<input
														type="email"
														id="email"
														value={this.state.email}
														maxLength="255"
														placeholder={
															translations.sections
																.reviewer_password_request
																.email_placeholder
														}
														disabled={isLoading}
														onKeyPress={e => this.handleKeyPress(e)}
														onChange={e => this.handleInputChange(e)}
													/>
												</div>

												<div className="btn_container">
													{errors.general && (
														<ErrorWrap animate={1}>
															{errors.general}
														</ErrorWrap>
													)}
													<Button
														text={
															translations.sections
																.reviewer_password_request.submit_button
														}
														classes={"submit-btn"}
														clickHandler={this.handleSubmit}
														{...this.props}
													/>
												</div>
											</React.Fragment>
										)}
								</div>
							</div>

							<PasswordRequestLinks />
						</React.Fragment>
					)}
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		errors: state.user.passwordRequestErrors,
		success: state.user.passwordRequestSuccess,
		isLoading: state.user.isLoading
	};
};

export default connect(
	mapStateToProps,
	{ passwordRequest, getTranslations }
)(PasswordRequest);



// WEBPACK FOOTER //
// ./src/components/reviewer/password-request/PasswordRequest.js